import React, { useState, useEffect } from "react";
import { Tabel, Badge, Loading } from "../core";
import { MoreOutlined } from "@ant-design/icons";
import { Menu, Dropdown } from "antd";

import { useHistory } from "react-router-dom";

import { getAllContracts, deleteContract } from "../helper/utils/api/contract";
import DeleteModals from "../components/Modals/deleteModals";

const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");
const ContractList = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = React.useState(false);
  const [contracts, setContracts] = React.useState([]);
  const [modalState, setModalState] = useState({
    editContractModal: false,
    deleteConfirmModal: false,
  });
  const [record, setRecord] = useState({
    recordToDelete: {},
    recordToEdit: {},
  });

  useEffect(() => {
    getAllContractFromDb();
  }, []);

  const getAllContractFromDb = async () => {
    let companyId = localStorage.getItem("companyId");

    setIsLoading(true);
    try {
      let {
        data: { result },
      } = await getAllContracts({ companyId });

      setContracts(result);
    } catch (error) {
      console.log("error from get contract", error);
    }
    setIsLoading(false);
  };

  const deleteContractHandler = (params) => {
    setModalState((prev) => ({
      ...prev,
      deleteConfirmModal: true,
    }));

    setRecord({
      recordToDelete: params,
      recordToEdit: {},
    });
  };

  const gotoContractInner = (record) => {
    history.push({
      pathname: `/contract-inner/${record.contractNo}`,
      state: record._id,
    });
  };

  const editContracthandler = (params) => {
    setModalState((prev) => ({
      ...prev,
      editBuyerModal: true,
    }));

    history.push({
      pathname: `/edit/${params.type}-contract/${params.contractNo}`,
      state: params._id,
    });
    setRecord({
      recordToDelete: {},
      recordToEdit: params,
    });
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const confirmDeleteHandler = async () => {
    debugger;
    if (record.recordToDelete) {
      let { _id } = record.recordToDelete;
      if (_id) {
        setIsLoading(true);
        try {
          await deleteContract(_id);
          closeModal("deleteConfirmModal");
          await getAllContractFromDb();
        } catch (error) {
          console.log("error delete", error);
        }
        setIsLoading(false);
      }
    }
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => gotoContractInner(record)}>view</Menu.Item>
        <Menu.Item onClick={() => deleteContractHandler(record)}>
          Delete
        </Menu.Item>
        <Menu.Item onClick={() => editContracthandler(record)}>Edit</Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "SNo",
      key: "S.No",
      width: 150,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Buyer Name",
      dataIndex: "buyerCompanyId",
      key: "buyerCompanyId",
      width: 150,
      render: (text, record, index) => (
        <span>{record.buyerCompanyId.buyerName}</span>
      ),
    },
    {
      title: "Contract #",
      dataIndex: "contractNo",
      key: "contractNo",
      width: 150,
    },
    {
      title: "Contract Type",
      dataIndex: "type",
      key: "type",
      width: 150,
    },
    {
      title: 'Quality (Reed*Pick/Wrap*Weft=Width"Type)',
      render: (text, record, index) => {
        let {
          clothQulaityId: { pick, reed, type, warp, width, weft },
        } = record;
        return (
          <span>
            {reed} * {pick} / {warp} * {weft} = {width}"{type}
          </span>
        );
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 150,
    },
    {
      title: "Date",
      dataIndex: "contractDate",
      key: "contractDate",
      render: (text, record, index) => {
        return (
          <span>
            {/* {record.invoice_date}
            <br /> */}
            {CHANGE_DATE_FORMAT.changeDateFormat(record.contractDate)}
          </span>
        );
      },
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "contractStatus",
      key: "contractStatus",
      render: (text) => <Badge status={text} text={text}></Badge>,
      width: 150,
    },
    {
      title: "",
      dataIndex: "action",
      width: 150,
      onCell: (record, rowIndex) => ({
        onClick: (e) => e.stopPropagation(),
      }),
      render: (text, record, index) => (
        <Dropdown
          overlay={() => menu(index, record)}
          onClick={(e) => e.stopPropagation()}
          trigger="click"
        >
          <MoreOutlined />
        </Dropdown>
      ),
    },
  ];

  return (
    <div>
      {isLoading ? <Loading /> : null}
      <Tabel
        columns={columns}
        data={contracts}
        rowKey="_id"
        onRow={(record) => ({
          onClick: () => {
            history.push({
              pathname: `/contract-inner/${record.contractNo}`,
              state: record._id,
            });
          },
        })}
      />

      {/* <FilterWraper
        rangeFilter={dateRange}
        inpputChange={changeInput}
        dropDown={false}
        range={true}
      >
        {saleRecord !== null ? (
          <Tabel columns={invoice} data={saleRecord} />
        ) : (
          <Loading />
        )}
      </FilterWraper> */}

      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}
    </div>
  );
};

export default ContractList;
